<template>
  <div class="swiperJob" :class="{ swiperObj: $store.state.innerWidth >= 815 }">
    <div class="swiperContent" ref="content">
      <swiper
        :options="swiperOption"
        v-if="showSwiper"
        :class="{ 'padding-30': showBtn }"
        class="swiperCarrousel SwiperArticles"
      >
        <swiper-slide
          class="swiper-slide box-slide"
          :class="{ 'swiper-no-swiping': !canSwiper }"
          v-if="index < 5"
          v-for="(jobFunction, index) in jobList"
        >
          <div class="boxShadow boxShadowJia pointer" ref="swiper" @click="goJobDetail(jobFunction)">
            <a href="javascript:;" style="color: inherit">
              <h5
                class="SemiBold jobTitle jobTitleJia mgBottom-11 mgBottom-28 wrap fourline-box"
                style="white-space:normal"
                v-html="$store.getters.getContent(jobFunction.title)"
              >
                <!-- {{ $store.getters.getContent(jobFunction.title) }} -->
              </h5>
            </a>
            <div class="item-table pad-7 mgBottom-11 mgBottom-28" v-if="$store.getters.getContent(jobFunction.organization)">
              <div class="tdcell iconWidth">
                <i class="icon-hourse"></i>
              </div>
              <div class="tdcell">
                <p
                  class="twoline-box"
                  v-html="$store.getters.getContent(jobFunction.organization)"
                ></p>
              </div>
            </div>
            <div class="item-table mgBottom-11 mgBottom-28" v-if="$store.getters.getContent(jobFunction.department)">
              <div class="tdcell iconWidth">
                <i class="icon-user"></i>
              </div>
              <div class="tdcell wrap mgBottom-11 mgBottom-28">
                <p class="twoline-box" v-html="$store.getters.getContent(jobFunction.department)"></p>
              </div>
            </div>
            <p class="gray dateTime" v-if="jobFunction.advertisingDay != null">
              {{ formatDay(jobFunction.advertisingDay) }}
            </p>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" v-if="showBtn" slot="button-prev">
        <i class="icon-arrow-down"></i>
      </div>
      <div class="swiper-button-next" v-if="showBtn" slot="button-next">
        <i class="icon-arrow-down"></i>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { EventBus } from "@/javascripts/eventBus.js";

export default {
  data() {
    return {
      totalRows: 0,
      showBtn: true,
      canSwiper: true,
      showSwiper: false,
      swiperOption: {
        autoHeight: true,
        slidesPerView: 2.2,
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    innerwidth() {
      return this.$store.state.innerWidth;
    },
    language() {
      return this.$store.state.language;
    },
    fontsize() {
      return this.$store.state.fontSize;
    },
  },
  watch: {
    innerwidth(news, old) {
      this.showSwiper = false;
      this.setWidth();
    },
    jobList: function (n, o) {
      this.setWidth();
    },
    language: function (n, o) {
      this.setWidth();
    },
    fontsize: function (n, o) {
      debugger;
      this.setWidth();
    },
  },
  props: {
    callback: null,
    jobList: null,
    occupationIds: 0,
    page: "",
  },
  methods: {
    goJobDetail: function (job) {
      this.$store.state.formData.jobId = job.id;
			if (this.$store.state.innerWidth > 768) {
        if (this.page == "OccupationDetails") {
          this.$store.state.formData.occupationId = this.occupationIds;
          this.$store.state.formData.relatedJobType = 1;
          this.$router.push({ path: "/RelatedVacancies", query: { lang: this.$store.state.language },});
        } else {
          this.$store.state.formData.hotJobList = this.jobList;
          EventBus.$emit("hotJobList",this.jobList);
          this.$router.push({ path: "/findAnOpportunity", query: { lang: this.$store.state.language }, });
        }
			} else {
				this.$router.push({ path: "/jobDetail/" + encodeURIComponent(job.id), query: { lang: this.$store.state.language,name:this.$store.getters.replaceEvent(this.$store.getters.getContent(job.title)) }, });
				window.scrollTo(0, 0);
			}

			window.scrollTo(0, 0);
      if (this.callback) this.callback();
    },
    formatDay: function (no) {
      let num = "";
      if (no >= 30) {
        num = Math.floor(no / 30) + this.$i18n.t("message.monthsAgo");
      } else if (no >= 7) {
        num = Math.floor(no / 7) + this.$i18n.t("message.weeksAgo");
      } else if (no == 0) {
        num = this.$i18n.t("message.today");
      } else {
        num = no + this.$i18n.t("message.daysAgo");
      }
      return num;
    },
    setWidth: function () {
      var that = this;
      this.$refs.content.style.width = "100%";
      if (this.$store.state.innerWidth >= 1345) {
        this.showBtn = false;
        this.canSwiper = false;
        // this.$refs.content.style.width= '100%'
      } else if (this.$store.state.innerWidth >= 1080) {
        this.showBtn = true;
        this.canSwiper = false;
        // this.$refs.content.style.width= 1118 + 'px'
      } else if (this.$store.state.innerWidth >= 815) {
        this.showBtn = true;
        this.canSwiper = false;
        // this.$refs.content.style.width= 855 + 'px'
      } else {
        this.showBtn = false;
        this.canSwiper = true;
        this.$refs.content.style.width = "100%";
      }
      if (this.$store.state.innerWidth >= 1345) {
        this.swiperOption = {
          slidesPerView: 5,
          spaceBetween: 15,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      } else if (this.$store.state.innerWidth >= 1080) {
        var space = (this.$store.state.innerWidth - 85 - 250 * 4) / 3;
        this.swiperOption = {
          slidesPerView: 4,
          spaceBetween: space,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      } else if (this.$store.state.innerWidth >= 815) {
        var space = (this.$store.state.innerWidth - 80 - 250 * 3) / 2;
        this.swiperOption = {
          slidesPerView: 3,
          spaceBetween: space,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      } else if (this.$store.state.innerWidth > 768) {
        this.swiperOption = {
          slidesPerView: 3,
          spaceBetween: 15,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      } else if (this.$store.state.innerWidth > 650) {
        this.swiperOption = {
          slidesPerView: 2.9,
          spaceBetween: 15,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      } else if (this.$store.state.innerWidth > 550) {
        this.swiperOption = {
          slidesPerView: 2.5,
          spaceBetween: 15,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      } else {
        this.swiperOption = {
          slidesPerView: 2.2,
          spaceBetween: 0,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      }
      var that = this;
      this.showSwiper = false;
      this.$nextTick(() => {
        this.showSwiper = true;
        setTimeout(function () {
          that.setHeightEvent();
        });
      });
    },
    setHeightEvent: function () {
      var height = 0;
      if (this.$refs.swiper) {
        for (var i = 0; i < this.$refs.swiper.length; i++) {
          if (this.$refs.swiper[i].offsetHeight > height) {
            height = this.$refs.swiper[i].offsetHeight;
          }
        }
        for (var i = 0; i < this.$refs.swiper.length; i++) {
          this.$refs.swiper[i].style.height = height + "px";
        }
      }
    },
  },
  mounted() {
    // this.mySwiper = new Swiper('.swiper-container')
    this.setWidth();
    var that = this;
    setTimeout(function () {
      that.setWidth();
    }, 500);
  },
};
</script>